import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { getQaAxiosClient, getQaConfiguration } from "../utils/saludV2Client";

export async function getNutriDoctors() {
  const config = getQaConfiguration();
  const token = JSON.parse(localStorage.getItem("token") || "null")?.idToken;
  if (!token) throw new Error("Inicie sesión nuevamente.");
  const response = await getQaAxiosClient(config).get("/usuariostranscripcion", {
    headers: { Authorization: `Bearer ${token}`, "x-access-token": token },
  });
  if (!Array.isArray(response.data)) throw new Error("Catálogo de profesionales no disponible.");
  return response.data.filter(user => Number.isSafeInteger(Number(user.id)) && Number(user.id) > 0
    && (user.estados === "Activo" || Number(user.estado) === 1)).map(user => ({
    id: Number(user.id), nombreCompleto: [user.nombres, user.apellidos].filter(Boolean).join(" "),
    profesion: user.descripcion || "",
  }));
}

export default function NutriDoctorSelect({ value, onChange, disabled }) {
  const [options, setOptions] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const enabled = getQaConfiguration().enabled;
  useEffect(() => {
    let cancelled = false;
    if (!enabled) return undefined;
    setLoading(true);
    getNutriDoctors().then(rows => { if (!cancelled) { setOptions(rows); setError(""); } })
      .catch(() => { if (!cancelled) setError("No se pudo cargar el catálogo de profesionales."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [enabled]);
  const selected = options.find(option => String(option.id) === String(value?.id)) || value;
  const available = selected && !options.some(option => String(option.id) === String(selected.id)) ? [selected, ...options] : options;
  return <Autocomplete fullWidth options={available} value={selected || null} disabled={disabled} loading={loading}
    isOptionEqualToValue={(option, current) => String(option.id) === String(current.id)}
    getOptionLabel={option => option.nombreCompleto
      ? `${option.nombreCompleto}${option.profesion ? " · " + option.profesion : ""}` : `ID ${option.id}`}
    onChange={(_, next) => onChange(next)}
    renderInput={params => <TextField {...params} label="Médico tratante" helperText={error || (selected ? `ID ${selected.id}` : "")} />} />;
}
